<!--sidebar right-->
<div class="sidebar-right p-3" [ngClass]="{'show' : sidebarToggle}"></div>
<div class="sidebar-right-overlay" (click)="toggleSidebar()" [ngClass]="{'show' : sidebarToggle}"></div>
<!--sidebar right-->
